function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoopOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.054 5.89652L16.1848 1L15.1649 2.02564L18.2875 5.1659H6.13825C4.05298 5.1659 2.33157 6.89829 2.33157 8.99331V14.5627H3.78647L3.7864 8.99344C3.7864 7.68201 4.83622 6.62714 6.13852 6.62714H18.2877L15.1649 9.76767L16.1848 10.7933L21.054 5.89652ZM20.8 9.76399H19.3451L19.3453 15.764H19.3067V15.914C19.3067 16.9933 18.4492 17.8542 17.3782 17.8542H4.76694L7.8895 14.7139L6.87008 13.6887L2 18.5457L6.86963 23.4429L7.8895 22.4172L4.76694 19.277H17.4166C19.2697 19.277 20.8 17.7778 20.8 15.8753V9.76399Z",
    fill: "#4B2B5A"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoopOn);
export default __webpack_public_path__ + "static/media/loop-on.c011ab21d8bf09d68154c765fdfe9820.svg";
export { ForwardRef as ReactComponent };